<div class="content {{ isM ? 'content--mobile' : '' }}">
  <app-full-height-container [isFullHeight]="true">
    <div class="back-header">
      <ion-toolbar class="app-toolbar">
        <ion-buttons slot="start">
          <ion-button (click)="onCancelClicked()" appHaptics color="primary">
            Cancel
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </div>

    <div class="announcement-view__title">
      <app-content-title>{{ announcement.title }}</app-content-title>
    </div>

    <div class="announcement-view__info">
      <div class="announcement-view__header">
        <h2 class="announcement-view__subheading">
          <span>
            {{ announcement ? fDateAndTime(announcement.date) : '' }} |
            {{ announcement?.authorName }}
          </span>
          <span>{{ editedString }}</span>
        </h2>
      </div>

      <div
        class="announcement-view__anonymous"
        *ngIf="
          announcement.isAnonymous &&
          announcement.announcementType === announcementType.SURVEY
        "
      >
        <ion-icon name="shield" color="warning" />
        <span class="announcement-view__subheading">
          Your responses will remain completely confidential.
        </span>
      </div>
    </div>

    <app-wysiwyg-editor
      *ngIf="announcement.announcementType === announcementType.ANNOUNCEMENT"
      [value]="body"
      mode="view"
    />
    <app-surveyjs-viewer
      #surveyjsViewer
      *ngIf="announcement.announcementType === announcementType.SURVEY"
      [value]="announcement.surveyJson"
      [user]="user"
      [isAnonymous]="announcement.isAnonymous"
      [completeHandler]="completeSurvey"
    />
    <app-announcement-thread [announcements]="thread" />

    <div
      class="modal-actions library-doc-button"
      *ngIf="announcement.libraryDoc"
    >
      <ion-button
        color="primary"
        appHaptics
        expand="block"
        [disabled]="announcementIndex === -1"
        [disableHaptics]="announcementIndex === -1"
        class="ion-no-margin"
        (click)="viewLibraryDocument()"
      >
        View Library Document
      </ion-button>
    </div>

    <div bottom class="modal-actions" *ngIf="announcement">
      <ion-button
        *ngIf="announcement.actions !== announcementActions.ONLY_RESPOND"
        color="dark"
        (click)="acknowledge()"
        appHaptics
        expand="block"
        [disabled]="announcementIndex === -1"
        [disableHaptics]="announcementIndex === -1"
        class="ion-no-margin"
      >
        {{
          announcement.acknowledgeButtonText | announcementAcknowledgeButtonText
        }}
      </ion-button>
      <ion-button
        *ngIf="
          announcement.actions !== announcementActions.ONLY_ACKNOWLEDGE &&
          announcement.author
        "
        color="dark"
        (click)="respond()"
        appHaptics
        expand="block"
        fill="outline"
        [disabled]="announcementIndex === -1"
        [disableHaptics]="announcementIndex === -1"
        class="ion-no-margin"
      >
        {{ announcement.respondButtonText | announcementRespondButtonText }}
      </ion-button>
    </div>
  </app-full-height-container>
</div>
